import { render } from "./BreathingVisual.vue?vue&type=template&id=726073b1&scoped=true"
import script from "./BreathingVisual.vue?vue&type=script&lang=js"
export * from "./BreathingVisual.vue?vue&type=script&lang=js"

import "./BreathingVisual.vue?vue&type=style&index=0&id=726073b1&scoped=true&lang=css"

import exportComponent from "/Users/mike/code/breathe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726073b1"]])

export default __exports__